import type { StyleProps} from '@chakra-ui/react'
import { Td, Tr } from '@chakra-ui/react'
import type { ReactNode } from 'react'

import { RowTableHeader } from '../RowTableHeader'

export interface TableSectionRowProps extends StyleProps {
  icon?: ReactNode
  title: ReactNode
  children: ReactNode
}

export const TableSectionRow = ({
  icon,
  title,
  children,
  ...rest
}: TableSectionRowProps) => (
  <Tr
    _first={{
      ' > td, > th': {
        pt: 4,
      },
    }}
    _last={{
      ' > td, > th': {
        pb: 4,
      },
    }}
    {...rest}
  >
    <RowTableHeader icon={icon} {...rest}>{title}</RowTableHeader>
    <Td>{children}</Td>
  </Tr>
)
